import { useQuery, gql } from "@apollo/client";

const PatientDiscountIncrements_Shared_Query = gql`
  query PatientDiscountIncrements_Shared_Query {
    currentStore {
      id
      patientDiscountIncrements
    }
  }
`;

interface PatientDiscountIncrementsQueryData {
  currentStore: {
    id: string;
    patientDiscountIncrements: number[];
  };
}

const usePatientDiscountIncrementsQuery = () =>
  useQuery<PatientDiscountIncrementsQueryData>(PatientDiscountIncrements_Shared_Query);

export type { PatientDiscountIncrementsQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { usePatientDiscountIncrementsQuery, PatientDiscountIncrements_Shared_Query };
